import React from 'react';
import { Link } from 'react-router-dom';
import './Services.css';

const services = [
  {
    title: 'Local Removals',
    icon: '🏠',
    image: 'local_removals.jpeg',
    description: 'Whether you are moving across the street or to the next suburb in Salisbury, Elizabeth, Munno Para, or Gawler, we have got you covered. Our local Adelaide moving services are fast, reliable, and cost-effective — ideal for short-distance moves throughout northern and all Adelaide suburbs.',
    features: ['Fast & efficient', 'Local expertise', 'Competitive pricing']
  },
  {
    title: 'Home Removals',
    icon: '🏢',
    image: 'home_removals.jpeg',
    description: 'Make your house move smooth and stress-free with Any Time Movers AU. Our experienced removalists serve Salisbury, Elizabeth, Munno Para, Gawler, Riverlea, and all Adelaide suburbs. We handle your belongings with care and precision, ensuring a safe transition to your new home.',
    features: ['Full service', 'Careful handling', 'On-time delivery']
  },
  {
    title: 'General Waste Removal',
    icon: '🗑️',
    image: 'general_waste_removals.jpeg',
    description: 'We do not just move — we clean up too. From leftover boxes to general household waste, we offer end-to-end waste management for your property. Prompt pickup and affordable pricing across Adelaide.',
    features: ['Eco-friendly', 'Quick pickup', 'All waste types']
  },
  {
    title: 'Concrete Removals',
    icon: '🛠️',
    image: 'concrete_removals.png',
    description: 'Need to clear broken concrete from a driveway, path, or construction site? Our team provides fast, safe, and eco-conscious concrete removal services across Adelaide. We handle the heavy lifting so you do not have to.',
    features: ['Heavy lifting', 'Safe disposal', 'Fast service']
  },
  {
    title: 'Hard Rubbish Removals',
    icon: '♻️',
    image: 'hard_rubbish_removals.png',
    description: 'Got bulky waste? We responsibly remove old furniture, appliances, and hard rubbish. Our eco-friendly disposal service operates across Adelaide with quick turnarounds and competitive pricing.',
    features: ['Eco-friendly disposal', 'Bulky items', 'Responsible removal']
  },
  {
    title: 'Office & Factory Removals',
    icon: '🏭',
    image: 'office_removals.png',
    description: 'Minimise downtime with our efficient office and factory removals. Whether relocating desks, machines, or entire workspaces, our team ensures secure transport for Adelaide businesses of all sizes.',
    features: ['Downtime minimized', 'Commercial expertise', 'Secure transport']
  },
  {
    title: 'Packaging & Unpackaging',
    icon: '📦',
    image: 'packaging_and_unpackaging.png',
    description: 'Leave the packing to us! We use premium materials to protect your items and can even unpack everything at your new location. A complete, hands-free moving experience tailored for convenience.',
    features: ['Premium materials', 'Full packing service', 'Careful unpacking']
  },
  {
    title: 'Storage Solutions',
    icon: '📋',
    image: 'storage_solutions.jpg',
    description: 'Need short- or long-term storage? Our secure, weatherproof storage units in Adelaide are perfect for storing furniture, personal items, or office equipment with 24/7 accessibility options.',
    features: ['Secure storage', '24/7 access', 'Climate controlled']
  },
];


const OurServices = () => {
  // Set SEO title
  React.useEffect(() => {
    document.title = "Adelaide Removalist Services | Local, Office & Home Moves | Any Time Movers AU";
  }, []);

  return (
    <div className="services-page">
      <section className="services-hero">
        <h1>Professional Adelaide Removalist Services</h1>
        <p>Any Time Movers AU - Serving City of Playford, City of Salisbury, City of Tea Tree Gully, City of Port Adelaide Enfield & all Adelaide suburbs</p>
      </section>

    <section className="services-grid-section">
      <div className="services-grid">
        {services.map((service, index) => (
          <div key={index} className="service-card">
            <div className="service-image-wrapper">
              <img src={service.image} alt={service.title} />
              <div className="service-icon-badge">{service.icon}</div>
            </div>
            <div className="service-content">
              <h3>{service.title} Adelaide</h3>
              <p>{service.description}</p>
              <ul className="service-features">
                {service.features.map((feature, i) => (
                  <li key={i}>
                    <span className="feature-icon">✓</span>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </section>

    <section className="services-cta">
      <h2>Ready to Get Started?</h2>
      <p>Get a free, no-obligation quote for any of our Adelaide removalist services</p>
      <div className="cta-buttons">
        <Link to="/quote" className="btn-primary">Get a Free Quote</Link>
        <a href="tel:0469303269" className="btn-secondary">Call Us Now</a>
      </div>
    </section>
  </div>
  );
};

export default OurServices;
